import { ReactSVG } from "react-svg";

const Switch = ({
  title,
  value,
  name,
  onUpdateSwitchValue,
  loading,
  description,
  link,
  list,
}) => {
  const updateSwitchValue = () => {
    list ? onUpdateSwitchValue(!value, name) : onUpdateSwitchValue(!value);
  };

  return (
    <div className="flex w-full items-center flex-wrap justify-between">
      {!loading ? (
        <label
          htmlFor={`toggle-${name}`}
          className="flex items-center flex-wrap gap-6 justify-between w-full cursor-pointer"
        >
          {/* text */}
          <div className="flex flex-col select-none">
            <div className="relative w-fit flex items-center flex-wrap">
              <span className="block mb-2">{title}</span>

              {link && (
                <a
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  className="translate-y-1.5 -left-10 top-0 w-10 h-10 flex items-start justify-end"
                >
                  <ReactSVG
                    src={`${process.env.PUBLIC_URL}/assets/images/icons/question.svg`}
                    className="w-5 mt-0.5 ml-1 text-gray-500"
                  />
                </a>
              )}
            </div>

            {description && (
              <span className="block text-sm text-gray-600">{description}</span>
            )}
          </div>

          {/* switch */}
          <div className="relative">
            <input
              type="checkbox"
              id={`toggle-${name}`}
              className="sr-only peer"
              checked={!!value}
              onChange={updateSwitchValue}
            />

            {/* background */}
            <div
              className="
                block rounded-full transition-all duration-300
                w-10 h-5
                bg-slate-400
                peer-checked:bg-green-500
              "
            ></div>

            {/* dot */}
            <div
              className="
                absolute
                left-0.5
                top-1/2
                -translate-y-1/2
                bg-white
                rounded-full
                transition-all
                duration-300
                w-4 h-4
                peer-checked:translate-x-5
              "
            ></div>
          </div>
        </label>
      ) : (
        <ReactSVG
          src={`${process.env.PUBLIC_URL}/assets/images/icons/loading-dot.svg`}
          className="w-11 ml-2 text-gray-500"
        />
      )}
    </div>
  );
};

export default Switch;
